@use "variables" as *;

.buyMeACoffeeLink {
  display: flex;
  justify-content: center;
}

.buyMeACoffeeButton {
  width: 118px !important;
  height: 38px !important;
}
